import { render, staticRenderFns } from "./ResearchQqPlotVector.vue?vue&type=template&id=5b4d2672"
import script from "./ResearchQqPlotVector.vue?vue&type=script&lang=js"
export * from "./ResearchQqPlotVector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b4d2672')) {
      api.createRecord('5b4d2672', component.options)
    } else {
      api.reload('5b4d2672', component.options)
    }
    module.hot.accept("./ResearchQqPlotVector.vue?vue&type=template&id=5b4d2672", function () {
      api.rerender('5b4d2672', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/vectorPlots/ResearchQqPlotVector.vue"
export default component.exports